// lib
import View from 'ln/view/View';
import Node from 'ln/node/Node';
import Lang from 'ln/lang/Lang';
import { scanner } from 'ln/view/Scanner';
import setup from 'ln/setup/setup';


class Newsfeed extends View {

    constructor() {

        super();

        this.defaultTemplate = 'krw.news-feeds'
    }

    public init(){

        super.init();
        // register on the panel button
        this.node.one( '.button' ).click.add( this.toggleNews, this );

    }

    protected renderData() {
        
        var showNews;
        try{
            // if nothing is in session storage
            if( sessionStorage.length == 0 ){
                showNews = 0;
                sessionStorage.setItem( 'showNews', '0' );
            } else {
                showNews = parseInt( sessionStorage.getItem( 'showNews' ) );
            }
        } catch ( exception ){
            // just render newsfeed closed
            showNews = 0;
        }
        return { feeds: setup.data( 'newsFeed' ), supportMail: setup.data( 'settings.support' ), text: Lang.translate( 'News' ), open: showNews };
    }

    
    /**
     * Toggle the news panel
     */
    private toggleNews( n:Node ){
        this.node.toggleClass( '-open' );
        
        try {
            if( parseInt( sessionStorage.getItem( 'showNews' ) ) == 0 ){
                sessionStorage.setItem( 'showNews', '1' );
            } else {
                sessionStorage.setItem( 'showNews', '0' );
            }
        } catch ( exception ){
            // do nothing
            console.warn( 'could not write to sessionStorage: ' + exception );
        }
    }

}

export default Newsfeed;

scanner.ioc.add( 'news-feed', function( node ) {
    return new Newsfeed().render( node );
});